import React from "react";

import { Row, Col } from "react-bootstrap";

import { Steps } from "antd";

const EvidencijeSteps = ({ currentStep, getStatus, steps }) => {
  const { Step } = Steps;

  return (
    <Row className="row justify-content-center">
      <Col className="align-self-center">
        <Row>
          <Col xl={8} lg={10} md={12}>
            <Steps current={currentStep}>
              {steps.map((step) => (
                <Step
                  key={step.key}
                  title={step.title}
                  description={step.description}
                  status={getStatus(step.key)}
                />
              ))}
            </Steps>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EvidencijeSteps;
